var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarWithTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 565.879,
    height: 338.421,
    viewBox: "0 0 565.879 338.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "matrix(-0.995, 0.105, -0.105, -0.995, 565.904, 288.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M21.622,7.828Q10.939,6.778.263,5.738A4.889,4.889,0,0,1,2.2,0Q12.877,1.049,23.556,2.089q-.968,2.869-1.933,5.739",
    transform: "translate(57.878 5.234)",
    fill: "#474c57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M.715,8.3C3.57.623,11.408,2.031,16.889,6.373c.3.237.6.477.9.7A10.426,10.426,0,0,1,24,.546c3.99-1.486,8.479.219,10.151,3.237,2.918-1.31,6.21-2.086,8.727-1.194a8.212,8.212,0,0,1,5.692,8.538c-.135,3.791-2.379,7.022-5.247,9.419a6.459,6.459,0,0,1,.3.6,4.78,4.78,0,0,1-1.285,5.9c-1.8,1.533-5.4,1.338-7.785.741a6.344,6.344,0,0,1-.075,2c-.943,4.821-5.6,3.093-6.57-.661-.273.383-.523.8-.773,1.229-2.084,3.537-6.113,5.939-9.368,2.289a6.854,6.854,0,0,1-.844-1.2A12.737,12.737,0,0,1,12.6,32.622c-3.625.329-5.846-.773-6.883-2.461-1.215-1.941-.935-4.7.458-7.108C1.487,19.615-1.425,14.04.715,8.3",
    transform: "translate(0 0.239)",
    fill: "#e2e7e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M.411,14.055C-1.4,7.237,3.033.16,8.7,0,15.014-.2,19.857,7.384,19.8,14.8c-.008,5.048-1.8,7.934-4.231,9.1C10.511,26.367,2.45,21.711.411,14.055",
    transform: "translate(44.65 39.03)",
    fill: "#edd5b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M304.606,121.008c-31.543,87.639-82.781,90.824-151.507,84.109C88.6,198.812,41.978,190.325,66.982,97.972-8.874,86.37-17.727,15.192,27.441,0c29.095,2.844,54.294,5.272,78.348,7.585l9.372.9c-4.184,9.606-4.089,19.9,3.628,25.642,8.024,5.976,22.344,4.313,34.123-7.819a34.134,34.134,0,0,0,8.255-13.388l8.932.867c42.629,4.14,89.306,8.759,154.968,15.492-4.484,9.564-4.564,19.977,3.364,25.742,8.033,5.85,22.343,4.261,34.1-7.553a32.731,32.731,0,0,0,8.349-13.442c39.39,4.126,78.906,8.392,117.345,12.731,6.831,11.132,8.228,27.1.663,42.3-13.78,27.7-43.151,35.751-71.619,38.433-38.468,3.622-86.337-1.1-112.659-6.488",
    transform: "translate(52.498 7.133)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M77.486,92.966l-1.035-.1C26.068,87.943-19.257,87.586,8.395,0l92.543,8.11Z",
    transform: "translate(135.351 109.264)",
    fill: "#e2e7e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M123.688,8.786C95.5,84.875,57.723,88.688,0,84.9L23.462,0Z",
    transform: "translate(219.975 118)",
    fill: "#e2e7e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M22.062,23.854c-7.09,7.229-15.053,8.278-19.172,4.78-10.034-8.516,8.3-34.526,20.826-27.418,6.374,3.614,6.592,14.221-1.653,22.638",
    transform: "translate(387.124 23.53)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M24.723,27.046c-7.729,8.209-16.6,9.4-21.3,5.445C-8.028,22.852,11.764-6.673,25.958,1.374c7.224,4.087,7.754,16.114-1.234,25.672",
    transform: "translate(174.749 0)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M22.739,56.232C15.495,51.089.549,22.125.117,12.236-.323,8.015.455,4,2.868,1.994A10.984,10.984,0,0,1,5.114.434c9.48-5.389,32.905,41.045,30.719,51.194-1.869,8.645-7.891,8.292-13.093,4.6",
    transform: "translate(145.887 133.122)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M4.468,16.038C1.824,14.782-.939,6.765.309,3.86A5.408,5.408,0,0,1,3.1.74,10.62,10.62,0,0,1,4.382.2c5.235-1.931,9.413,10.934,6.9,14.009a5.536,5.536,0,0,1-6.814,1.833",
    transform: "translate(191.482 169.839)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M17.766,62.663C11.271,61.536,3.824,55.5,0,48.072a29.575,29.575,0,0,0,8.085-2.165,55.974,55.974,0,0,0,9.681,16.756M330.293,21.7c-4.482,9.56-4.563,19.976,3.367,25.739,8.035,5.849,22.342,4.261,34.1-7.554a32.741,32.741,0,0,0,8.35-13.441l8.949.937c-23.24,57.932-86.265,41.391-64.117-6.642ZM120.389.9c-4.184,9.605-4.09,19.9,3.628,25.643,8.024,5.977,22.342,4.315,34.124-7.819A34.136,34.136,0,0,0,166.4,5.341l8.93.868C151.985,64.9,89.827,48.569,111.017,0ZM101.243,74.828q11.13.894,22.255,1.791c-1.7,13.532-23.763,10.531-22.255-1.791m361.689,35.65C459.408,88.45,474.925,69.625,498.5,68.323a48.647,48.647,0,0,1-4.383,13.158c-7.052,14.174-18.181,23.2-31.181,29",
    transform: "translate(47.269 14.715)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M29.025,0c3.492,5.143,4.229,12.432,1.337,19.508C25.875,30.485,14.351,36.793,4.622,33.595A15.693,15.693,0,0,1,0,31.172C3.407,17.05,11.38,4.339,29.025,0",
    transform: "translate(513.684 86.556)",
    fill: "#edd5b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M232.038,75.16c-13.836,8.032-11.775,13.408,30.508-1.371,33.383-11.674,71.207-23.7,69.912-27.126C331.532,44.218,302.4,38,275.285,33.455c-21.327-3.576-41.108-7.465-41.982-5.937-.9,1.578,3.547,4.166,6.176,5.545-14.492,1.069-38.361-3.594-56.9-7.485-14.364-3.014-25.966-5.572-26.631-4.463-1.019,1.693,4.944,4.9,8.247,6.826C134.279,18.9,109.253,13.577,78.363,6.673,68.229,4.406,47.083-1.68,45.979.442,44.539,3.2,53.912,9.19,57.112,11.705,32.151,8.928,20.3,6.875,19.549,9.279c-.72,2.294,14.656,5.568,39.021,11.046C30.592,23.2,6.025,22.623,5.108,26.061,3.447,32.313,15.473,37.874,49.331,46.4,22.244,48.308,4.765,49.233,3.437,52.137,1.663,56.009,22.77,61.506,58.985,68.072,15.809,74.44-.214,78.351,0,80.8c.264,2.954,27.172,5.131,52.747,4.172-14.009,7.163-30.37,15.659-28.415,19.6C28.9,113.794,115.046,91.75,158.874,86.1c-10.6,7.255-5.062,7.185,6.62,4.437,17.349-4.078,54.769-14.7,66.543-15.378",
    transform: "translate(38.978 166.491)",
    fill: "#2a8b5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M1.859,77.341C1.611,78.3-.076,78.386,0,77.5c.256-2.859,2.123-9.756,2.872-13.024C3.8,60.425,4.794,56.568,5.626,52.5,8.807,36.97,9.614,21.047,10.182,5.343c.057-1.607.1-3.22.142-4.823C10.337-.06,12.388-.31,12.362.6c-.4,13.935-.956,27.948-2.883,41.793C8.063,52.563,5.526,62.555,3.094,72.449L2.421,74.94c-.244.909-.318,1.491-.562,2.4",
    transform: "translate(160.011 184.104)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M76.355,35.7c-15,18.106-35,32.73-57.391,39.705-4.495,1.4-9.18,2.72-13.746,2.679-2.034-.019-5.006-.506-5.207-3A5.936,5.936,0,0,1,1.453,71.3c2.419-3.362,5.814-5.907,9.086-8.339,10.813-8.042,20.17-12.519,32.4-17.508,8.9-3.635,17.705-6.676,26.706-9.974q2.494-.936,4.991-1.868C68.24,28.391,61.323,22.764,54.778,17.94,46.852,12.109,37.36,5.665,28.387,2.266,27.2,1.813,27.127,1.31,27.2.788c.085-.569.432-1.11,1.926-.555C40.039,4.288,59.991,19.249,69.3,26.922c1.846,1.541,6.709,5.784,7.257,6.284a2.232,2.232,0,0,1,.811.151c.2-.137,17.456-9.463,33.343-16.794,13.574-6.262,26.977-11.553,30.65-12.932,1.9-.748,1.81.913,1.261,1.176-.159.074-.388.185-.388.185-2.693.966-16.644,6.964-30.886,13.425C95.442,25.641,78.669,34.486,78.432,34.574c.1.24,6.037,3.26,8.766,5.224,12.132,8.732,21.306,22.87,27.225,36.331a40.529,40.529,0,0,1,3.1,10.736,12.1,12.1,0,0,1-.005,4.276c-.406,1.854-1.812,3.226-3.831,2.821-5.117-1.03-12.457-11.853-14.607-15.208l-2.057-3.3c-6.334-10.57-12.006-21.542-17.3-32.592-1.117-2.306-2.355-4.718-3.372-7.157M114.14,92.459c1.164.209,1.757-.927,1.922-1.888a15.779,15.779,0,0,0-.584-6.169,44.961,44.961,0,0,0-2.727-8.117c-6.1-13.519-14.47-26.317-26.518-35.175a56.823,56.823,0,0,0-7.068-4.539l2.755,6.15q6.513,13.466,13.936,26.471A129.467,129.467,0,0,0,104.5,83.056c1.8,2.376,6.572,8.834,9.642,9.4M3.842,76.109c3.539.634,7.367-.254,10.727-1.059C31.148,71.087,47.942,61.01,60.813,49.7a145.147,145.147,0,0,0,13.3-13.322l-3.69,1.269C61.649,40.806,52.868,44,44.236,47.457c-4.141,1.645-8.289,3.333-12.329,5.212C23.338,56.664,12.3,63.641,5.36,70.2c-1.136,1.072-3.038,2.86-3.321,4.469-.179,1.01,1.053,1.3,1.8,1.435",
    transform: "translate(89.578 205.363)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWithTree);
export default __webpack_public_path__ + "static/media/carWithTree.9a5c1e5009e257f73d457683ae36549a.svg";
export { ForwardRef as ReactComponent };